import Vue from 'vue';

export default Vue.directive('img', {
    bind(el, binding) {
        el.style.opacity = '0';

        el.onload = () => {
            el.style.transition = 'opacity 400ms ease-in-out';
            el.style.opacity = '1';
        };
    },
});
